import React from "react"

// Mui
import { AppBar, Box, useTheme, Toolbar, Typography, IconButton } from "@mui/material"

// Icons
import { ArrowLeft } from "iconsax-react"

// Next Link
import Link from "next/link"

// ------------------------------------------|| MOBILE WRAPPER - COMPONENTS ||----------------------------------------

const MobileWrapper = props => {
  const { sx, centralizer = false, toolBar = false, toolbarTitle = "", toolbarHref, children } = props

  // Use Theme
  const theme = useTheme()

  return (
    <Box
      sx={{
        ...sx,
        p: 0,
        minHeight: "calc(100vh - 56px)",
        display: centralizer ? "flex" : "",
        justifyContent: centralizer ? "center" : "",
        alignItems: centralizer ? "center" : "",
      }}
    >
      {toolBar && (
        <AppBar
          position='sticky'
          sx={{ background: theme.palette.mode === "dark" ? "" : "#fff", color: theme.palette.text.primary }}
          elevation={0}
        >
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography variant='h5'>{toolbarTitle}</Typography>
            {toolbarHref && (
              <IconButton color='primary' component={Link} href={toolbarHref}>
                <ArrowLeft />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      )}

      <Box sx={{mt:1, p: 2,  background: theme.palette.mode === "dark" ? "#232424" : "#fff" }}>
        {children}
      </Box>
    </Box>
  )
}

export default MobileWrapper
